var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"text-center"},[_c('div',{staticClass:"text-center"},[_c('h3',{staticClass:"text-h3 mb-6",staticStyle:{"margin-top":"10px"}},[_vm._v("Vos résultats")])])])
}]

export { render, staticRenderFns }